// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Fiche d'un évènement de tag : consultation pleine largeur, blocs \`.form-section\` sur surface blanche
   (docs/ui-design-guidelines.md §12), valeurs en grille de micro-libellés (§14). */
.ted-page {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.ted-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.ted-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
}

.ted-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-left: auto;
}

.ted-error {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

:host ::ng-deep .ted-banner {
  width: 100%;
}

.ted-error p-message {
  flex: 1;
}

.ted-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.ted-schedule-value {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.ted-schedule-editor {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background: var(--tj-white-background);
  border-radius: var(--p-border-radius-md);
}
.ted-schedule-editor .field-title {
  margin: 0;
}
.ted-schedule-editor .field-help {
  margin-top: 0;
}

.ted-schedule {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
}

.ted-schedule-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.ted-history {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1.5rem;
}

.ted-history-runs {
  flex: 0 1 20rem;
}

.ted-history-contacts {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1 1 36rem;
  min-width: 0;
}

.ted-run-row {
  cursor: pointer;
}

.ted-number {
  text-align: right;
}

.ted-subtitle {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}

.ted-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 0;
}

.ted-progress-detail {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1rem;
  text-align: center;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/tags/tags-event-detail/tags-event-detail.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;mFAAA;AAGA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,WAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,OAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;EACA,WAAA;AACJ;;AAGA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAAJ;;AAIA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,sCAAA;EACA,wCAAA;AADJ;AAGI;EACI,SAAA;AADR;AAII;EACI,aAAA;AAFR;;AAMA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;AAHJ;;AAMA;EACI,aAAA;EACA,yBAAA;EACA,SAAA;AAHJ;;AAOA;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;AAJJ;;AAOA;EACI,eAAA;AAJJ;;AAOA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;AAJJ;;AAOA;EACI,eAAA;AAJJ;;AAOA;EACI,iBAAA;AAJJ;;AAOA;EACI,SAAA;EACA,eAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;AAJJ;;AAOA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAJJ;AACA,gxJAAgxJ","sourcesContent":["/* Fiche d'un évènement de tag : consultation pleine largeur, blocs `.form-section` sur surface blanche\n   (docs/ui-design-guidelines.md §12), valeurs en grille de micro-libellés (§14). */\n\n.ted-page {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.ted-header {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n}\n\n.ted-heading {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 1rem;\n}\n\n.ted-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    margin-left: auto;\n}\n\n.ted-error {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n}\n\n:host ::ng-deep .ted-banner {\n    width: 100%;\n}\n\n.ted-error p-message {\n    flex: 1;\n}\n\n.ted-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}\n\n// Programmation lue en texte, « Modifier » à côté.\n.ted-schedule-value {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n// Saisie de la programmation : un encart gris dans le bloc blanc, le temps de la modification.\n.ted-schedule-editor {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n    background: var(--tj-white-background);\n    border-radius: var(--p-border-radius-md);\n\n    .field-title {\n        margin: 0;\n    }\n\n    .field-help {\n        margin-top: 0;\n    }\n}\n\n.ted-schedule {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 1rem;\n}\n\n.ted-schedule-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n}\n\n// Historique : les applications à gauche, les contacts de l'application choisie à droite.\n.ted-history {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    gap: 1.5rem;\n}\n\n.ted-history-runs {\n    flex: 0 1 20rem;\n}\n\n.ted-history-contacts {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    flex: 1 1 36rem;\n    min-width: 0;\n}\n\n.ted-run-row {\n    cursor: pointer;\n}\n\n.ted-number {\n    text-align: right;\n}\n\n.ted-subtitle {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 500;\n}\n\n.ted-progress {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    margin: 0;\n}\n\n.ted-progress-detail {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    margin-top: 1rem;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
